// extracted by mini-css-extract-plugin
export default {"container":"T0-z","heading":"U0-z","links":"V0-z","copy":"W0-z","subCopy":"X0-z","linksLeft":"Y0-z","linksCenter":"Z0-z","linksRight":"_0-z","link":"a1-z","onlyLink":"b1-z"};